import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { Region } from './region.interface';

export class RegionService {
   async getRegions(): Promise<Array<Region>> {
      return await http.get('/regions', cacheFirstConfig).then((response) => response.data);
   }

   async getRegionsById(regionId: number): Promise<Region> {
      return await http.get(`/regions/${regionId}`, cacheFirstConfig).then((response) => response.data);
   }
}
